import { DEFAULT_FORMAT_DATE_TIME } from "constants/datetime";

import { Box, Grid, IconButton } from "@mui/material";
import { Badge, CheckCircleIcon, Typography } from "components";
import Clock from "components/Icon/Clock";
import InfoCircle from "components/Icon/InfoCircle";
import X from "components/Icon/X";
import XCircle from "components/Icon/XCircle";
import { gray } from "configs/colors";
import {
  NotificationEntity,
  NotificationEntityActionType,
  NotificationEntityTargetType,
} from "generated";
import { formatDate } from "helpers";
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";

type Props = {
  data: NotificationEntity;
  handleDeleteOneNotification: (id: string) => void;
  handleReadOneNotification: (id: string) => void;
};

export const NotificationItem = (props: Props) => {
  const { data, handleDeleteOneNotification, handleReadOneNotification } =
    props;
  const navigate = useNavigate();
  const handleRedirectUrl = (
    type: NotificationEntityTargetType,
    id: string
  ) => {
    switch (type) {
      case NotificationEntityTargetType.Request: {
        return navigate(`/pre-employment-check/request/detail/${id}`);
      }
      case NotificationEntityTargetType.RequestCandidate: {
        return window.open(id);
      }
      default:
        return "";
    }
  };
  const handleIconNotification = (action: NotificationEntityActionType) => {
    switch (action) {
      case NotificationEntityActionType.Approve: {
        return <CheckCircleIcon fontSize="small" sx={{ color: gray[700] }} />;
      }
      case NotificationEntityActionType.Reject: {
        return <XCircle fontSize="small" sx={{ color: gray[700] }} />;
      }
      default:
        return <InfoCircle fontSize="small" sx={{ color: gray[700] }} />;
    }
  };
  return (
    <Grid
      display="flex"
      justifyContent="space-between"
      sx={
        data.readAt
          ? { borderBottom: "solid 1px #D0D5DD" }
          : {
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              backgroundColor: "#F9F5FF",
              borderBottom: "solid 1px #6941C6",
            }
      }
      padding="14px"
    >
      <Grid display="flex" alignItems="center">
        <Grid
          marginRight={2}
          display="flex"
          alignItems="center"
          sx={{
            padding: "10px",
            border: "solid 1px",
            borderColor: gray[200],
            background: "white",
            borderRadius: "8px",
            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
          }}
        >
          {handleIconNotification(data.actionType)}
        </Grid>
        <Typography type="TextSM">
          <Grid display="flex" gap="14px" marginBottom={1}>
            <Box component="b">{data.title}</Box>
            <Grid display="flex">
              <Grid marginRight={1} display="flex" alignItems="center">
                <Clock fontSize="small" sx={{ color: "#475467" }} />
              </Grid>
              <Typography type="TextSM">
                {formatDate(data.createdAt, DEFAULT_FORMAT_DATE_TIME)}
              </Typography>
            </Grid>
          </Grid>
          <Box component="span">
            {parse(data.content ?? "")}&nbsp;
            {data.targetId && (
              <Box component="span">
                Review it&nbsp;
                <Box
                  component="b"
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleReadOneNotification(data.id as string);
                    handleRedirectUrl(data.targetType, data.targetId as string);
                  }}
                >
                  here
                </Box>
                .
              </Box>
            )}
          </Box>
        </Typography>
      </Grid>

      <IconButton
        onClick={() => {
          handleDeleteOneNotification(data.id as string);
        }}
      >
        <X sx={{ color: gray[500] }} />
      </IconButton>
    </Grid>
  );
};
